import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import Button from '../buttons/Rounded';
import ForgotPasswordForm from '../forms/ForgotPassword';
import MainLayout from '../layouts/Main';
import FormFrame from '../partials/FormFrame';

import styles from '../../../styles/pages/form.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ForgotPasswordPage = ({ className }) => {
    const route = useUrlGenerator();
    const location = useLocation();
    const [success, setSuccess] = useState();

    const onComplete = useCallback(() => {
        setSuccess(true);
    }, []);

    useScrollToTop(location);

    return (
        <MainLayout>
            <div
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <div className={styles.inner}>
                    <FormFrame
                        className={styles.formFrame}
                        title={
                            <FormattedMessage
                                defaultMessage="Forgot password?"
                                description="Form heading"
                            />
                        }
                    >
                        {success ? (
                            <>
                                <p className={styles.formSuccess}>
                                    <FormattedMessage
                                        defaultMessage="Thank you! You will receive an email with a reset password link shortly."
                                        description="Form message"
                                    />
                                </p>
                                <Button className={styles.button} href={route('login')}>
                                    <FormattedMessage
                                        defaultMessage="Go to login"
                                        description="Form button"
                                    />
                                </Button>
                            </>
                        ) : (
                            <>
                                <p className={styles.formDescription}>
                                    <FormattedMessage
                                        defaultMessage="Please enter your email and we'll send you a link to reset your password."
                                        description="Form description"
                                    />
                                </p>
                                <ForgotPasswordForm onComplete={onComplete} />
                            </>
                        )}
                    </FormFrame>
                </div>
            </div>
        </MainLayout>
    );
};
ForgotPasswordPage.propTypes = propTypes;
ForgotPasswordPage.defaultProps = defaultProps;

export default ForgotPasswordPage;
